import { InspirationalGridLine } from 'Components/lines/inspirational-grid-line/InspirationalGridLine';

export default InspirationalGridLine;
